module.exports = __webpack_public_path__ + "static/media/Quiz_Card_JP.049f1ceb.jpg";